export enum ECreateNftType {
  REGULAR,
  UTILITY,
  IMPORT
}
